import {BaseEntity} from "../../entities/BaseEntity";
import {ImportModel} from "../../models/import/ImportModel";
import {NotificationService} from "../../services/NotificationService";
import { StateService } from "@uirouter/angularjs";

export class ImportConfirmCtrl<T extends BaseEntity>{
    public static $inject = ['$scope','$state','ImportModel','NotificationService'];
    currentPage:number = 1;
    working:boolean = false;
    constructor(public $scope:any, public stateService:StateService, public model:ImportModel<T>, public notifyService:NotificationService) {
        this.$scope.vm = this;
        this.$scope.$watch(() => this.currentPage,(newValue: string, oldValue: string) => {
            if(newValue != oldValue) {

            }
        });
    }
    previous():void{
        this.stateService.go(this.model.getRoute("mapfields"));
    }
    next():void{
      this.working = true;
      this.model.doImport(false).then((ok)=>{
          if(ok){
              this.stateService.go(this.model.getRoute("summary"));
          }
          else
          {
              this.currentPage = 1;
              this.stateService.go(this.model.getRoute("fixerrors"));
          }
      }).catch((exc)=>{
        this.notifyService.notifyError("Got error in testing import:"+exc);
      }).finally(()=>{
        this.working = false;
      });
    }
}
